import React from 'react';
// Import Components
import { HeaderBanner } from '../HeaderBanner';
import { Footer } from '../Footer';
import { PageWrapper } from './PageWrapper';

/**
 * This is the Layout Component
 * Wrap any page in this "template" to display the global header and footer
 * this will also give any page access to Theming and the UserProvider context component
 */
export function Layout(_ref) {
  var _ref$boxSizing = _ref.boxSizing,
      boxSizing = _ref$boxSizing === void 0 ? 'border-box' : _ref$boxSizing,
      children = _ref.children,
      _ref$inverseLinkColor = _ref.inverseLinkColors,
      inverseLinkColors = _ref$inverseLinkColor === void 0 ? false : _ref$inverseLinkColor,
      _ref$isHeroVisible = _ref.isHeroVisible,
      isHeroVisible = _ref$isHeroVisible === void 0 ? true : _ref$isHeroVisible,
      _ref$isOverlappingHer = _ref.isOverlappingHero,
      isOverlappingHero = _ref$isOverlappingHer === void 0 ? false : _ref$isOverlappingHer,
      _ref$meta = _ref.meta,
      meta = _ref$meta === void 0 ? {} : _ref$meta;
  return /*#__PURE__*/React.createElement(PageWrapper, {
    className: inverseLinkColors && 'inverse',
    boxSizing: boxSizing,
    meta: meta
  }, /*#__PURE__*/React.createElement(HeaderBanner, {
    isAbsolute: isHeroVisible,
    isOverlappingHero: isOverlappingHero
  }), children, /*#__PURE__*/React.createElement(Footer, null));
}